import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { userService } from "../../_services";
import UserTrainingModule from './TrainingModule';
import { Card, CardContent } from "../ui/card";
import { GraduationCap, Loader2 } from "lucide-react";

/**
 * User Training Page
 * Modernized with shadcn components - Training modules for distributors
 */
function UserTraining() {
    const [trainingModuleData, setTrainingModuleData] = useState(null);
    const [moduleLoader, setModuleLoader] = useState(true);
    const [userId, setUserId] = useState('');
    const [userName, setUserName] = useState('');

    useEffect(() => {
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const [id, name] = Usermeta_Data.split(':');
            setUserId(id);
            setUserName(name);
            getTrainingModules(id, name);
        } catch (error) {
            console.error('Error initializing training page:', error);
            window.location.href = '/signup';
        }
    }, []);

    const getTrainingModules = async (userId, userName) => {
        try {
            const Module = "Distributor";
            const apiData = await userService.TrainingMedia(userId, userName, Module);
            
            if (apiData && apiData.length > 0) {
                const moduleData = apiData[0].modules.filter((item) => item.media && item.media.length > 0);
                setTrainingModuleData(moduleData);
            }
        } catch (error) {
            console.error('Error fetching training modules:', error);
        } finally {
            setModuleLoader(false);
        }
    };

    // Auth check
    if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
        return <Navigate to="/signup" replace />;
    }

    if (window.atob(localStorage.getItem('UserRole')) !== "Distributor") {
        return <Navigate to="/page-not-found" replace />;
    }

    localStorage.setItem('pagename', 'trainingpageuser');

    return (
        <div className="w-full space-y-6">
            {/* Page Header */}
            <div className="flex items-center gap-3">
                <h1 className="text-3xl font-bold tracking-tight text-foreground">Training</h1>
            </div>

            {/* Training Content */}
            <Card>
                <CardContent className="p-0">
                    {moduleLoader ? (
                        <div className="flex items-center justify-center py-12">
                            <Loader2 className="h-12 w-12 animate-spin text-brand-accent" />
                        </div>
                    ) : trainingModuleData && trainingModuleData.length > 0 ? (
                        <div>
                            {trainingModuleData.map((item, index) => (
                                <UserTrainingModule 
                                    key={index} 
                                    moduleData={item}
                                    isLast={index === trainingModuleData.length - 1}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-12 px-6">
                            <GraduationCap className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
                            <p className="text-muted-foreground">No training modules available at this time.</p>
                        </div>
                    )}
                </CardContent>
            </Card>
        </div>
    );
}

export default UserTraining;
